<template>
  <div :class="$style.modalBody">
    <h1>Testing Modal</h1>
    <p>This is only for testing. You shouldn't be seeing this.</p>
    <footer :class="$style.footer">
      <FlatActionButton
        :action="handleClose"
        text="close"
      />
      <a
        href="#/users"
        @click="handleClose"
      >
        Go to users page
      </a>
    </footer>
  </div>
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import LocalStorageService from 'client/util/LocalStorageService';
import ModalEventBus from 'components/Modal/ModalEventBus';

const { loginModalTestingSeen } = LocalStorageConsts;

export default {
  name: 'LoginModalTesting',

  components: {
    FlatActionButton,
  },

  LocalStorageService,

  methods: {
    handleClose() {
      const { setItem } = this.$options.LocalStorageService;

      ModalEventBus.close();
      setItem(loginModalTestingSeen, 'seen');
    },
  },
};
</script>

<style module>
.modalBody {
  --jc-spacer-medium: 1.5rem;

  padding: var(--jc-spacer-medium);
}

.footer {
  align-items: center;
  display: flex;
  gap: var(--jc-spacer-medium);
  padding: var(--jc-spacer-medium) 0;
}
</style>
